const config = {
  baseUrl: "https://us-central1-sherpa-98bf5.cloudfunctions.net/api",
};
export default config;
